import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { Category, CategoryInput, CategoryLookup, PagedList, Pagination } from '#models';

export interface PagedCategoryRequest {
  filter: { businessUnitId: number };
  pagination: Pagination;
}

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  private _httpClient = inject(HttpClient);

  getCategories(businessUnitId: number): Observable<Category[]> {
    return this._httpClient.get<Category[]>(`${environment.apiUrl}/businessunits/${businessUnitId}/categories`);
  }

  createCategory(businessUnitId: number, data: CategoryInput): Observable<Category> {
    return this._httpClient.post<Category>(`${environment.apiUrl}/businessunits/${businessUnitId}/categories`, data);
  }

  getCategory(categoryId: number): Observable<Category> {
    return this._httpClient.get<Category>(`${environment.apiUrl}/categories/${categoryId}`);
  }

  getCategoryDetails(categoryId: number): Observable<Category> {
    return this._httpClient.get<Category>(`${environment.apiUrl}/categories/${categoryId}/details`);
  }

  updateCategory(categoryId: number, data: Partial<CategoryInput>): Observable<Category> {
    return this._httpClient.put<Category>(`${environment.apiUrl}/categories/${categoryId}`, data);
  }

  deleteCategory(categoryId: number): Observable<void> {
    return this._httpClient.delete<void>(`${environment.apiUrl}/categories/${categoryId}`);
  }

  getPagedCategories(request: PagedCategoryRequest): Observable<PagedList<Category>> {
    return this._httpClient.post<PagedList<Category>>(`${environment.apiUrl}/categories/paged`, request);
  }

  importCategory(data: CategoryLookup): Observable<Category[]> {
    return this._httpClient.post<Category[]>(`${environment.apiUrl}/categories/import`, data);
  }
}
